var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProdejnyMapPathAmsterdam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "118.658px",
    height: "236.842px",
    viewBox: "0 0 118.658 236.842",
    enableBackground: "new 0 0 118.658 236.842",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.912,
    strokeMiterlimit: 10,
    d: "M80.373,16.408 c-0.403,1.606-0.879,3.139-1.42,4.602"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeDasharray: "7,7",
    d: "M74.419,29.942 C59.815,63.921,30.22,67.707,44.944,104.747c13.406,33.73,62.944-21.11,40.372,50.064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.19,152.421c0,2.404-1.95,4.353-4.353,4.353s-4.353-1.95-4.353-4.353c0-2.404,1.95-4.353,4.353-4.353 S90.19,150.017,90.19,152.421"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 82.114,
    cy: 8.754,
    r: 3.482
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdejnyMapPathAmsterdam);
export default __webpack_public_path__ + "static/media/prodejny_map_path_amsterdam.0c51486ed2e406fe13a725a633eb20d6.svg";
export { ForwardRef as ReactComponent };